import React from 'react';

import cx from 'classnames';

import {
  EditButton,
  usePageContext,
  useEditContext,
} from '@xingternal/pages-common';

import styles from './GalleryEditButton.css';

type GalleryEditButtonProps = {
  inFullWidth?: boolean;
};
const GalleryEditButton = ({ inFullWidth = false }: GalleryEditButtonProps) => {
  const { pageContext } = usePageContext();
  const { isEditing } = useEditContext();
  const isFreePage = pageContext.contractType === 'FREE';

  if (isFreePage || !isEditing) {
    return null;
  }

  return (
    <EditButton
      size={'small'}
      showIcon
      className={cx(styles.editGallery, { [styles.fullWidth]: inFullWidth })}
      to={`${pageContext.basePath}/${pageContext.pageSlug}/edit/gallery`}
      data-testid="edit-gallery-preview"
    />
  );
};

export default GalleryEditButton;
